document.addEventListener('DOMContentLoaded', function() {
  const swipers = document.querySelectorAll('.wp-block-mitery-blocks-home-slider .home-slider-slider');
  swipers.forEach(sliderElement => {
    new Swiper(sliderElement, {
      loop: true,
      navigation: {
        nextEl: ".home-slider-button-next",
        prevEl: ".home-slider-button-prev",
      },
    });
  });
});